import { useRef } from 'react'

import { ButtonPrimary } from 'components/Button/Button'
import styled from 'styled-components'
import { Upload } from 'share-ui/components/Icon/Icons'

export default function InputFileUpload({
    label,
    onChange,
}: {
    label: string
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}) {
    const fileInputRef = useRef<HTMLInputElement>(null)

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click()
        }
    }

    return (
        <>
            <ButtonPrimary onClick={handleButtonClick}>
                <StyledUpload />
                {label}
            </ButtonPrimary>
            <VisuallyHiddenInput type='file' onChange={onChange} ref={fileInputRef} />
        </>
    )
}

const VisuallyHiddenInput = styled.input`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
`

const StyledUpload = styled(Upload)`
    path {
        fill: ${({ theme }) => theme.body.textColorTertiary};
    }
`
